import React from 'react';
import Grid from "@mui/material/Grid";
import {Checkbox, FormControlLabel, Paper} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useDispatch} from "react-redux";
import Typography from "@mui/material/Typography";
import NautilusText from "../../Common/NautilusText";
import {getFormattedDate, ExtraActivityDate} from '../../../utils/utils';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        marginBottom: theme.spacing(8),
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: '75%',
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    paper: {
        padding: theme.spacing(0),
        width: 'calc(100% - 24px)',
        margin: 'auto',
        marginLeft: '24px',
    },
    mainContainer: {
        padding: theme.spacing(1),
    },
    roomInfoContainer: {
        marginTop: 20,
        width: '100%'
    },
    ActivityListInfo: {
        display: 'flex',
        width: '100%',
        paddingBottom: 0,
        paddingTop: 0,
        '-webkit-flex-direction': 'column',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
    }

}));

const Extra = ({activity, value, handleChange}) => (
    <Grid container spacing={3}>
        <Grid item xs={12} sm={6} className="roomContainer" style={{display: 'flex', alignContent: 'center'}}>
            <img src={activity['image']} alt="Activity" width={'100%'}
                 className={'activityImage'}/>
        </Grid>
        <Grid item xs={12} sm={6} className="ActivityContainer" justify="left">
            <Typography variant="h3" align="left" style={{padding: '10px', fontSize: '22px'}}>
                {`${activity['name']} ($${parseFloat(activity['price']).formatMoney(0)}/person)`}
            </Typography>
            <Typography variant="h5" align="left" style={{padding: '10px 12px 10px'}}>
                {activity['description'].split('##More Information')[0]}
            </Typography>
            <NautilusText name="source" value={value} variant="outlined"
                          select
                          onChange={e => handleChange(activity.id, e.target.value, true)}
                          SelectProps={{native: true,}} style={{padding: '10px 12px 10px'}}>
                <option value="">Select your date</option>
                {activity && 'availabilities' in activity &&
                    Object.keys(activity['availabilities']).length > 0 &&
                    Object.keys(activity['availabilities']).map((dates) => (
                        <option key={dates} value={dates}>
                            {ExtraActivityDate(activity['availabilities'][dates]['date'])}
                        </option>
                    ))}
            </NautilusText>
        </Grid>
    </Grid>
);

const Complimentary = ({activity, value, handleChange}) => (
    <>
        {Object.keys(activity.availabilities).map(dates => (
            <Grid item xs={12} sm={12} key={dates}>
                <FormControlLabel
                    className={'cleanCheckbox'}
                    control={<Checkbox checked={dates === value}
                                       name={dates}
                                       onChange={e => handleChange(activity.id, e.target.name)}
                                       color="primary"/>}
                    label={`${activity['name']} - ${getFormattedDate(activity['availabilities'][dates]['date'])}`}/>
            </Grid>
        ))}
        <Grid item xs={12} sm={12} className={'imageContainer'}>
            <img src={activity['image']} alt="Activity" width={'100%'} className={'activityImage'}/>
        </Grid>
    </>
);

const Activity = ({activity, extra, selectedOption, handleChange}) => {
    const classes = useStyles();
    // const dispatch = useDispatch();

    // const currentValue = complimentary ? complimentary[activity.id] : '';
    // const currentValue = '';

    /*const handlerActivity = (event) => {
        const {checked, name} = event.target;
        // dispatch(setComplimentaryActivities(activity.id, name, checked));
    }*/

    return (
        <div className={classes.root}>
            <Grid container spacing={3} direction="column" justify="center">
                {activity && 'availabilities' in activity && Object.keys(activity['availabilities']).length > 0 && (
                    <Grid item container className={classes.mainContainer}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <Paper className={classes.paper} elevation={3}>
                                    {extra ? <Extra activity={activity} value={selectedOption}
                                                    handleChange={handleChange}/> :
                                        <Complimentary activity={activity} value={selectedOption}
                                                       handleChange={handleChange}/>}
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </div>
    );
};

export default Activity;
